import React from "react";

import { SearchResultsContainer } from "../SearchResultsContainer";

import "./searchDropdown.scss";

export default function SearchDropdown({ isLoading, query, queryResults }) {
  return (
    <div className="search-dropdown">
      <SearchResultsContainer
        isLoading={isLoading}
        query={query}
        queryResults={queryResults}
      />
    </div>
  );
}
